module.exports = __webpack_public_path__ + "img/i2r-bg-big-tall.a903f28c.png";